/*

To implement the concept of "Tours" (main location is sending teams to satellites), we need to distinguish between different types of "Locations".
"plan locations" are ["KA", "SP", "LB", "KR", "RN"] - actual locations where a service takes place
"scheduling locations are ["KA/", "SP/", "KR/", "RN/", "Tour/LB", "Tour/RN"] - each of these can have different cost structure and are showing differently (it is important to know whether somebody is assigned to "Tour/RN" or "Tour/LB" at a certain date)
"location groups" (or "user locations") are what the workers see, e.g. when configuring their preferences (["KA", "SP", "RN", "KR", "Tour"]). They cannot distinguish between different targets of the Tour.

*/


export function getLocationGroupFromLocation(loc)
{
    if (loc == "" || loc == undefined)
        return loc;
  if (loc.includes("/"))
    return loc.split("/")[0];
  throw new Error("Invalid location name: must contain /: " + loc);
}

export function getPlanLocationFromLocation(loc)
{
    if (loc == "" || loc == undefined)
        return loc;
  if (loc.startsWith("Tour/"))
    return loc.substring(5);
  else if (loc.substring(loc.length-1) == "/")
    return loc.substring(0, loc.length-1);
    else throw new Error("unexpected loc");
}


// WEBPACK FOOTER //
// ./src/features/home/location_helpers.js